<template>
  <div class="modal counter-offer-modal">
    <div class="overlay" @click="$parent.closeCounterOfferModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeCounterOfferModal"
              src="./../images/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">COUNTER OFFER</div>

                <div class="offer-items">
                  <div class="offer-items-header">
                    <span class="col-name">Item</span>
                    <span class="col-qty">Qty</span>
                  </div>
                  <div
                    class="offer-item-row"
                    v-for="(item, i) in $parent.counterOfferRequest.items"
                    :key="i"
                  >
                    <span class="col-name">{{ item.short_name }}</span>
                    <span class="col-qty">x{{ item.quantity }}</span>
                  </div>
                </div>

                <div class="offer-summary">
                  <div class="summary-row">
                    <span class="summary-label">Your price:</span>
                    <span class="summary-value your-price">
                      {{ $parent.counterOfferRequest.total_amount }}
                      <img src="./../images/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                  <div class="summary-row highlight">
                    <span class="summary-label">Admin offer:</span>
                    <span class="summary-value offer">
                      {{ $parent.counterOfferRequest.counter_offer_amount }}
                      <img src="./../images/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                </div>

                <div class="counter-offer-note">
                  By accepting, your items will be removed from the game and the offered amount will be credited to your payout balance.
                </div>

                <transition name="slide">
                  <div v-if="$parent.counterOfferError" class="error-desc desc red">
                    {{ $parent.counterOfferError }}
                  </div>
                </transition>

                <div class="counter-offer-buttons">
                  <button
                    class="button"
                    @click="$parent.approveCounterOffer"
                    :disabled="$parent.sellRequestActionLoading"
                  >
                    {{ $parent.sellRequestActionLoading ? 'PROCESSING...' : 'ACCEPT' }}
                  </button>
                  <button
                    class="button black"
                    @click="$parent.declineCounterOffer($parent.counterOfferRequest.id)"
                    :disabled="$parent.sellRequestActionLoading"
                  >DECLINE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CounterOfferModal",
};
</script>

<style scoped lang="scss">
.counter-offer-modal {
  .close {
    filter: brightness(0) invert(1);
  }

  .container {
    padding: 34px;
  }

  .form-fields-wrapper {
    text-align: center;
    max-width: 520px;
    margin: 0 auto;
    font-family: "Open Sans", sans-serif;
    color: #fff;
  }

  .title {
    margin-bottom: 24px;
  }

  .offer-items {
    text-align: left;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    overflow: hidden;
  }

  .offer-items-header {
    display: flex;
    padding: 10px 14px;
    background: rgba(255, 255, 255, 0.05);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
  }

  .offer-item-row {
    display: flex;
    padding: 10px 14px;
    font-size: 14px;
    color: #fff;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .col-name {
    flex: 1;
  }

  .col-qty {
    width: 60px;
    text-align: center;
  }

  .coin-sm {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: relative;
    top: 1px;
  }

  .offer-summary {
    margin-bottom: 20px;
    text-align: left;
  }

  .summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 15px;

    &.highlight {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      padding-top: 12px;
      margin-top: 4px;
    }
  }

  .summary-label {
    color: rgba(255, 255, 255, 0.5);
  }

  .summary-value {
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 4px;

    &.offer {
      color: #ff8400;
      font-size: 16px;
    }
  }

  .counter-offer-note {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .error-desc {
    margin-bottom: 16px;
    font-size: 14px;
    text-align: center;
    color: #ff5050 !important;
  }

  .counter-offer-buttons {
    display: flex;
    gap: 12px;

    .button {
      flex: 1;
      min-width: 0;
      margin-top: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .counter-offer-modal .container {
    padding: 20px 12px;
  }
}
</style>

